import { Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useThemeContext } from '../../../contexts/BaseThemeContextProvider';

const PrimaryBlueButton = ({ onClick, buttonText, isLoading, additionalProps, sxProps = {} }) => {
  const [loading, setLoading] = useState(false);
  const { theme } = useThemeContext();

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  const defaultSxProps = {
    borderRadius: '24px',
    textTransform: 'none',
    padding: '8px 24px',
    background: theme.buttons.primaryBlue.background,
    border: `2px solid ${theme.buttons.primaryBlue.borderColor}`,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
    '&:hover': {
      background: theme.buttons.primaryBlue.hover.background,
      border: `2px solid ${theme.buttons.primaryBlue.hover.borderColor}`,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
    },
    '&.Mui-disabled': {
      backgroundColor: theme.buttons.primaryBlue.disabled.background,
      border: `2px solid ${theme.buttons.primaryBlue.disabled.borderColor}`,
      color: theme.buttons.primaryBlue.disabled.color,
    },
  };

  if (onClick) {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        disabled={loading}
        sx={{
          ...defaultSxProps,
          ...sxProps,
        }}
        {...additionalProps}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
      </Button>
    );
  } else {
    return (
      <Button
        variant="contained"
        color="primary"
        disabled={loading}
        sx={{
          ...defaultSxProps,
          ...sxProps,
        }}
        {...additionalProps}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
      </Button>
    );
  }
};

PrimaryBlueButton.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isLoading: PropTypes.bool,
  additionalProps: PropTypes.object,
};

export default PrimaryBlueButton;
